import { isEventbriteTLD } from '../selectors/app';
import { isSplitTreatmentEnabled } from '../selectors/splitio';
import { CheckoutState } from '../state';
import { ENABLE_INTERSTITIAL_STEP } from '../utils/splitio';

export const isStatsigFreeTrialEnabled = (state: CheckoutState): boolean =>
    isEventbriteTLD(state) &&
    isSplitTreatmentEnabled(state, ENABLE_INTERSTITIAL_STEP);
